/* ClayTech Pump Selector — AIMS Industrial
   Decision tree and pump specs are a direct port of AIMS_ClayTechPumpSelector_Tool_28Aug26.html.

   One substantive change: price and stock are no longer trusted from the hardcoded values.
   They are refreshed from Shopify's own /products/<handle>.js at the moment a result renders,
   so the tool can never show a stale price. The baked-in figures remain as a fallback if the
   fetch fails. As shipped, three SKUs in the source file were already out of date.

   Everything is inside one IIFE: nothing is added to window. */
(function () {
  'use strict';

  var SITE = '';                 // same-origin; keeps the tool working on preview themes
  var priceCache = {};           // handle -> product json
  var inflight = {};

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* Refresh every price and stock pill currently on screen from live product data. */
  function refreshLive(root, handles) {
    handles.forEach(function (h) {
      if (priceCache[h]) { apply(root, priceCache[h]); return; }
      if (inflight[h]) return;
      inflight[h] = true;
      fetch('/products/' + h + '.js', { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (p) { priceCache[h] = p; apply(root, p); })
        .catch(function () { /* keep the baked-in fallback */ })
        .then(function () { inflight[h] = false; });
    });
  }

  function apply(root, product) {
    (product.variants || []).forEach(function (v) {
      var id = String(v.id);
      var pEl = root.querySelector('[data-cps-price="' + id + '"]');
      if (pEl && typeof v.price === 'number') pEl.textContent = money(v.price);
      var sEl = root.querySelector('[data-cps-stock="' + id + '"]');
      if (sEl) {
        var ok = v.available;
        sEl.textContent = ok ? 'In stock' : 'Out of stock';
        sEl.classList.toggle('is-out', !ok);
      }
    });
  }

  function init(root) {

    var PUMPS = {
      cmsC7A1: {
        name: "CMS C7A1", desc: "Submersible + automatic mains valve.",
        flow: 95, head: 46, power:{out:750,in:null},
        variants:[{label:"CMS C7A1", handle:"claytech-cms-c7a1-divertron-c7-submersible-pressure-pump-1-acquasaver", variantId:"49300866203925", sku:"A0170891", price:1411.47, stock:true}]
      },
      divertron6taps36: {
        name: "DiverTron 6 Taps (36m)", desc: "Bare submersible pump, no valve.",
        flow: 95, head: 36, power:{out:650,in:null},
        variants:[{label:"650W", handle:"claytech-divertron-submersible-pressure-pump-6-taps", variantId:"49340039921941", sku:"A0170865", price:916.67, stock:true}]
      },
      divertron6taps46: {
        name: "DiverTron 6 Taps (46m)", desc: "Bare submersible pump, no valve.",
        flow: 95, head: 46, power:{out:750,in:null},
        variants:[{label:"750W", handle:"claytech-divertron-submersible-pressure-pump-6-taps", variantId:"49340039954709", sku:"A0170866", price:1071.35, stock:true}]
      },
      bluediverAcqua: {
        name: "BlueDiver + AcquaSaver", desc: "Submersible + automatic mains valve.",
        flow: 95, head: 36, power:{out:650,in:null},
        variants:[
          {label:"1&Prime; valve", handle:"claytech-bluediver-submersible-pump-and-acquasaver", variantId:"49408057803029", sku:"A0170875", price:1279.70, stock:true},
          {label:"3/4&Prime; valve", handle:"claytech-bluediver-submersible-pump-and-acquasaver", variantId:"49408057835797", sku:"A0170876", price:1102.60, stock:true}
        ]
      },
      c6divertronAcqua: {
        name: "C6 Divertron + AcquaSaver", desc: "Submersible + automatic mains valve.",
        flow: 95, head: 36, power:{out:650,in:null},
        variants:[
          {label:"1&Prime; valve", handle:"c6-divertron-submersible-pressure-pump-acquasaver", variantId:"49493140701461", sku:"A0170883", price:1354.18, stock:true},
          {label:"3/4&Prime; valve", handle:"c6-divertron-submersible-pressure-pump-acquasaver", variantId:"49493140668693", sku:"A0170884", price:1177.08, stock:true}
        ]
      },
      cmsC5A2: {
        name: "CMS C5A2", desc: "Above-ground surface pump + automatic mains valve.",
        flow: 63, head: 43, power:{out:475,in:null}, suction:8,
        variants:[{label:"CMS C5A2", handle:"claytech-cseries-pressure-pump-and-acquasaver", variantId:"49493140570389", sku:"A0170882", price:1798.96, stock:true}]
      },
      inoxController: {
        name: "Multi-Stage Pump &amp; Controller", desc: "Above-ground surface pump + AquaTron controller, no valve.",
        flow: 100, suction:4,
        variants:[
          {label:"550W &middot; 35m", handle:"claytech-multi-stage-pump-and-controller", variantId:"49340040380693", sku:"A0170867", price:916.67, stock:true, head:35, power:{out:550,in:null}},
          {label:"750W &middot; 48m", handle:"claytech-multi-stage-pump-and-controller", variantId:"49340040413461", sku:"A0170868", price:1031.25, stock:true, head:48, power:{out:750,in:null}},
          {label:"985W &middot; 60m", handle:"claytech-multi-stage-pump-and-controller", variantId:"49340040446229", sku:"A0170869", price:1088.54, stock:true, head:60, power:{out:985,in:null}}
        ]
      },
      inoxBare: {
        name: "Surface Mounted Bare Pump", desc: "Same pump, no controller &mdash; pair with one you already have.",
        flow: 100, suction:4,
        variants:[
          {label:"550W &middot; 35m", handle:"claytech-surface-mounted-bare-pump-without-controller", variantId:"49340042346773", sku:"A0170870", price:973.96, stock:true, head:35, power:{out:550,in:null}},
          {label:"750W &middot; 48m", handle:"claytech-surface-mounted-bare-pump-without-controller", variantId:"49340042379541", sku:"A0170871", price:1088.54, stock:true, head:48, power:{out:750,in:null}},
          {label:"985W &middot; 60m", handle:"claytech-surface-mounted-bare-pump-without-controller", variantId:"49340042412309", sku:"A0170872", price:1203.13, stock:true, head:60, power:{out:985,in:null}}
        ]
      },
      aquatronController: {
        name: "AquaTron2P Controller", desc: "Standalone controller only.",
        variants:[{label:"AquaTron2P", handle:"claytech-aquatron2p-controller-pump-controller-10-bar-150-x-140-x-230mm", variantId:"49300866138389", sku:"A0170888", price:97.40, stock:true}]
      },
      drainagePumpBare36: {
        name: "Drainage Pump (36m)", desc: "Bare submersible pump, no valve, no controller.",
        flow: 95, head: 36, power:{out:650,in:null},
        variants:[{label:"650W", handle:"claytech-drainage-pump", variantId:"49340204024085", sku:"A0170849", price:819.27, stock:true}]
      },
      drainagePumpBare46: {
        name: "Drainage Pump (46m)", desc: "Bare submersible pump, no valve, no controller.",
        flow: 95, head: 46, power:{out:750,in:null},
        variants:[{label:"750W", handle:"claytech-drainage-pump", variantId:"49340204056853", sku:"A0170850", price:802.08, stock:true}]
      },
      drainagePumpAquatron36: {
        name: "Drainage Pump + AquaTron (36m)", desc: "Submersible + dry-run protection, no valve.",
        flow: 95, head: 36, power:{out:650,in:null},
        variants:[{label:"650W", handle:"claytech-drainage-pump-aquatron-pump-controller", variantId:"49340204384533", sku:"A0170851", price:842.19, stock:true}]
      },
      drainagePumpAquatron46: {
        name: "Drainage Pump + AquaTron (46m)", desc: "Submersible + dry-run protection, no valve.",
        flow: 95, head: 46, power:{out:750,in:null},
        variants:[{label:"750W", handle:"claytech-drainage-pump-aquatron-pump-controller", variantId:"49340204417301", sku:"A0170852", price:899.48, stock:true}]
      },
      blueSub10: {
        name: "BlueSub10", desc: "Heaviest-duty dewatering pump in the range.",
        flow: 250, head: 18, power:{out:750,in:null}, particle:"25 &times; 10mm",
        variants:[{label:"BlueSub10", handle:"claytech-blue-sub10-submersible-light-construction-pump-w-float-250l-min-750w", variantId:"49300865581333", sku:"A0170858", price:481.25, stock:true}]
      },
      blueVort9: {
        name: "BlueVort9", desc: "Handles soft solids &amp; stringy material.",
        flow: 200, head: 8.5, power:{out:450,in:null}, particle:"25mm",
        variants:[{label:"BlueVort9", handle:"claytech-cla-bluevort-9-submersible-drainage-pump-200-l-min", variantId:"49300865876245", sku:"A0170859", price:309.38, stock:true}]
      },
      blueVort7: {
        name: "BlueVort7", desc: "Lighter-duty vortex pump for soft solids.",
        flow: 135, head: 7, power:{out:180,in:null}, particle:"15mm",
        variants:[{label:"BlueVort7", handle:"claytech-cla-bluevort-7-submersible-drainage-pump-135-l-min", variantId:"49300865941781", sku:"A0170860", price:252.08, stock:true}]
      },
      bvpc11: {
        name: "BVPC11", desc: "Biggest mover in the dirty-water range.",
        flow: 320, head: 11, power:{out:600,in:null}, particle:"38mm",
        variants:[{label:"BVPC11", handle:"claytech-cla-bvp-c11-drainage-pump-11m-head-320-l-min", variantId:"49300866007317", sku:"A0170861", price:744.79, stock:true}]
      },
      pitbull15: {
        name: "Pitbull15", desc: "High-head specialist &mdash; basements, waste-water systems.",
        flow: 170, head: 15, power:{out:550,in:750},
        variants:[{label:"Pitbull15", handle:"claytech-pitbull-15-drainage-pump-0-75kw-170l-min", variantId:"49300866171157", sku:"A0170890", price:515.63, stock:true}]
      },
      prosub: {
        name: "ProSub", desc: "Small sump pump with an integrated float switch.",
        particle:"5mm",
        variants:[
          {label:"170W &middot; 6.5m &middot; 125L/min", handle:"claytech-prosub-drainage-pump", variantId:"49340043034901", sku:"A0170873", price:343.75, stock:true, head:6.5, flow:125, power:{out:170,in:null}},
          {label:"250W &middot; 9m &middot; 195L/min", handle:"claytech-prosub-drainage-pump", variantId:"49340043067669", sku:"A0170874", price:458.33, stock:true, head:9, flow:195, power:{out:250,in:null}}
        ]
      },
      claWp15: {
        name: "CLA-WP15", desc: "Petrol engine-driven transfer pump &mdash; no mains power needed.",
        flow: 300, head: 25, suction: 8, engine:"3.0HP petrol", ports:"1.5\" BSP",
        variants:[{label:"CLA-WP15", handle:"claytech-cla-wp15-engine-driven-transfer-pump-300-l-min", variantId:"49300866498837", sku:"A0170895", price:687.50, stock:true}]
      },
      subpond300: {
        name: "SubPond 300", desc: "Small fountain or pond.",
        flow: 140, head: 7, power:{out:200,in:null},
        variants:[{label:"SubPond 300", handle:"claytech-subpond-pond-pump", variantId:"49340045033749", sku:"A0170885", price:286.46, stock:true}]
      },
      subpond700: {
        name: "SubPond 700", desc: "Larger pond or waterfall.",
        flow: 240, head: 10, power:{out:550,in:null},
        variants:[{label:"SubPond 700", handle:"claytech-subpond-pond-pump", variantId:"49340045066517", sku:"A0170886", price:481.25, stock:true}]
      }
    };


    function fmtPrice(p){ return "$" + p.toFixed(2); }
    function $(id){ return root.querySelector('[data-cps-el="' + id + '"]'); }



    var STATE = {tank:null, topup:null};

    function pressureLeaf(demand){
      if (STATE.tank === "above" && STATE.topup === "yes"){
        return {title:"Above ground, auto top-up", pumps:["cmsC5A2"], also:null};
      }
      if (STATE.tank === "above" && STATE.topup === "no"){
        return {title:"Above ground, tank only", pumps:["inoxController"],
          also:"Already have a controller? <b>Surface Mounted Bare Pump</b> (SKU A0170870/71/72) is the same pump without one &mdash; ask the team for this one instead."};
      }
      if (STATE.tank === "below" && STATE.topup === "yes"){
        if (demand === "high") return {title:"Below ground, auto top-up", pumps:["cmsC7A1"], also:null};
        return {title:"Below ground, auto top-up", pumps:["c6divertronAcqua","bluediverAcqua"],
          also:"Two equivalent 650W/36m pumps under different ClayTech names &mdash; pick whichever valve size fits your plumbing."};
      }
      if (demand === "high") return {title:"Below ground, tank only", pumps:["divertron6taps46","drainagePumpBare46"],
        also:"Two equivalent 750W/46m bare pumps under different names &mdash; either is a genuine match."};
      return {title:"Below ground, tank only", pumps:["divertron6taps36","drainagePumpBare36"],
        also:"Two equivalent 650W/36m bare pumps under different names &mdash; either is a genuine match."};
    }

    var DRAINAGE_LEAVES = {
      "clean-small": {title:"Clean water, occasional", pumps:["prosub"], also:null},
      "clean-high": {title:"Clean water, high volume", pumps:["blueSub10","pitbull15"],
        also:"BlueSub10 moves more flow; Pitbull15 is the high-head specialist for basements or waste-water systems."},
      "dirty-small": {title:"Dirty water, occasional", pumps:["blueVort7"], also:null},
      "dirty-high": {title:"Dirty water, high volume", pumps:["bvpc11","blueVort9"],
        also:"BVPC11 is the biggest mover (38mm solids); BlueVort9 suits greywater or final-stage pump-out."}
    };

    var POND_LEAVES = {
      small: {title:"Small pond or fountain", pumps:["subpond300"], also:null},
      large: {title:"Larger pond or waterfall", pumps:["subpond700"], also:null}
    };

    function showPanel(id){
      root.querySelectorAll(".cps__panel").forEach(function(p){ p.classList.remove("is-active"); });
      var panel = $(id);
      panel.classList.add("is-active");
      var total = panel.getAttribute("data-total-steps");
      if (total && total !== "0"){
        var stepMap = {
          "panel-pressure-q1":1, "panel-pressure-q2":2, "panel-pressure-q3":3,
          "panel-drainage-q0":1, "panel-drainage-q1":2, "panel-drainage-q2":3,
          "panel-pond-q1":1
        };
        $("stepCount").innerHTML = "Step <b>" + (stepMap[id] || 1) + "</b> of " + total;
      } else {
        $("stepCount").textContent = "";
      }
      if (root.getBoundingClientRect().top < 0) {
        root.scrollIntoView({behavior:"smooth", block:"start"});
      }
    }

    function specHtml(p, v){
      var head = v.head !== undefined ? v.head : p.head;
      var flow = v.flow !== undefined ? v.flow : p.flow;
      var power = v.power || p.power;
      var items = [];
      if (power){
        var val = power.out + '<span class="cps-s-unit">W</span>';
        if (power.in) val += '<span class="cps-s-sub">' + power.in + 'W input (P1)</span>';
        items.push(["Output (P2)", val]);
      }
      if (flow !== undefined) items.push(["Max flow", flow + '<span class="cps-s-unit">L/min</span>']);
      if (head !== undefined) items.push(["Max head", head + '<span class="cps-s-unit">m</span>']);
      if (p.suction) items.push(["Suction lift", p.suction + '<span class="cps-s-unit">m</span>']);
      if (p.particle) items.push(["Max particle", p.particle]);
      if (p.engine) items.push(["Engine", p.engine]);
      if (p.ports) items.push(["Ports", p.ports]);
      return items.map(function(it){
        return '<div class="cps-spec-item"><div class="cps-s-label">' + it[0] + '</div><div class="cps-s-value">' + it[1] + '</div></div>';
      }).join("");
    }

    function renderPumpCard(pumpKey){
      var p = PUMPS[pumpKey];
      var html = '<div class="cps-spec-card"><h3>' + p.name + '</h3><p class="cps-p-desc">' + p.desc + '</p>';
      var perVariantSpecs = p.variants.some(function(v){ return v.power || v.head || v.flow; }) && !p.power && !p.head;
      var topSpecs = specHtml(p, {});
      if (topSpecs) html += '<div class="cps-spec-grid">' + topSpecs + '</div>';
      html += '<div class="cps-sku-list">';
      p.variants.forEach(function(v){
        html += '<div class="cps-sku-row">' +
          '<div class="cps-sku-main"><span class="cps-sku-name">' + v.label + '</span><span class="cps-sku-meta">SKU ' + v.sku + '</span></div>' +
          '<div class="cps-sku-right">' +
            '<span class="cps-stock" data-cps-stock="' + v.variantId + '">' + (v.stock ? 'In stock' : 'Check stock') + '</span>' +
            '<span class="cps-price" data-cps-price="' + v.variantId + '">' + fmtPrice(v.price) + '</span>' +
            '<a class="cps-sku-link" href="' + SITE + '/products/' + v.handle + '?variant=' + v.variantId + '" target="_blank" rel="noopener">View</a>' +
          '</div></div>';
      });
      html += '</div></div>';
      return html;
    }

    function renderResult(title, pumpKeys, also){
      $("resTitle").textContent = title;
      $("resultCards").innerHTML = pumpKeys.map(renderPumpCard).join("");
      $("alsoNote").innerHTML = also ? '<div class="cps-also-note">' + also + '</div>' : "";
      showPanel("panel-results");
    }

    root.querySelectorAll("[data-go]").forEach(function(btn){
      btn.addEventListener("click", function(){
        if (btn.hasAttribute("data-set")) STATE[btn.getAttribute("data-set")] = btn.getAttribute("data-val");
        showPanel("panel-" + btn.getAttribute("data-go"));
      });
    });

    root.querySelectorAll("[data-result]").forEach(function(btn){
      btn.addEventListener("click", function(){
        var key = btn.getAttribute("data-result");
        if (key === "engine") renderResult("No mains power", ["claWp15"], null);
        else if (key === "parts") renderResult("Controllers &amp; bare pumps", ["aquatronController","inoxController","inoxBare","drainagePumpAquatron36","drainagePumpAquatron46"], null);
      });
    });

    root.querySelectorAll("[data-demand]").forEach(function(btn){
      btn.addEventListener("click", function(){
        var leaf = pressureLeaf(btn.getAttribute("data-demand"));
        renderResult(leaf.title, leaf.pumps, leaf.also);
      });
    });

    root.querySelectorAll('[data-set="topup"]').forEach(function(btn){
      btn.addEventListener("click", function(){
        if (STATE.tank === "above" && btn.getAttribute("data-val") === "yes"){
          var leaf = pressureLeaf(null);
          renderResult(leaf.title, leaf.pumps, leaf.also);
        }
      });
    });

    root.querySelectorAll('[data-cps-el="panel-drainage-q2"] [data-set="volume"]').forEach(function(btn){
      btn.addEventListener("click", function(){
        var leaf = DRAINAGE_LEAVES[STATE.water + "-" + btn.getAttribute("data-val")];
        renderResult(leaf.title, leaf.pumps, leaf.also);
      });
    });

    root.querySelectorAll('[data-cps-el="panel-pond-q1"] [data-set="pond"]').forEach(function(btn){
      btn.addEventListener("click", function(){
        var leaf = POND_LEAVES[btn.getAttribute("data-val")];
        renderResult(leaf.title, leaf.pumps, leaf.also);
      });
    });

    $("startAgainBtn").addEventListener("click", function(){
      STATE.tank = null; STATE.topup = null; STATE.water = null;
      showPanel("panel-entry");
    });

    /* After any result renders, pull live price and stock for the handles on screen. */
    var _renderResult = renderResult;
    renderResult = function (title, pumpKeys, also) {
      _renderResult(title, pumpKeys, also);
      var handles = [];
      pumpKeys.forEach(function (k) {
        (PUMPS[k].variants || []).forEach(function (v) {
          if (handles.indexOf(v.handle) === -1) handles.push(v.handle);
        });
      });
      refreshLive(root, handles);
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'pump_selector_result', { result_title: title, pumps: pumpKeys.join(',') });
      }
    };
  }

  function boot() {
    var roots = document.querySelectorAll('[data-cps]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].getAttribute('data-cps-ready') === '1') continue;
      roots[i].setAttribute('data-cps-ready', '1');
      init(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
